import { takeEvery, put } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';
import AssetTagsAPI from '~/api/asset-tags-api';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';
import type {
  addAssetTagRelationshipsAction,
  removeAssetTagRelationshipsAction,
} from './actions';
import AssetTagsRelationshipConstants from './constants';
import { createBatches } from './utils';

const TAG_ASSET_BATCH_SIZE = 200;

export function* addAssetTagRelationship({
  payload,
}: ReturnType<typeof addAssetTagRelationshipsAction>) {
  // Todo: Check if any of the batched request fails, and in that case write an error message somewhere
  const batches = createBatches(payload, TAG_ASSET_BATCH_SIZE);

  yield put({
    type: AssetTagsRelationshipConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST,
    payload,
  });

  for (const batch of batches) {
    const response = yield* callRequestSaga(
      AssetTagsAPI.addAssetTagRelationships,
      {
        request:
          AssetTagsRelationshipConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST,
        payload: batch,
      },
      batch.tag.id,
      batch.assets
    );

    if (response instanceof BaseException) {
      // Do something
    }
  }

  yield put({
    type:
      AssetTagsRelationshipConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS,
    payload,
  });
}

export function* removeAssetTagRelationship({
  payload,
}: ReturnType<typeof removeAssetTagRelationshipsAction>) {
  // Todo: Check if any of the batched request fails, and in that case write an error message somewhere
  const batches = createBatches(payload, TAG_ASSET_BATCH_SIZE);

  yield put({
    type: AssetTagsRelationshipConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST,
    payload,
  });

  for (const batch of batches) {
    const response = yield* callRequestSaga(
      AssetTagsAPI.removeAssetTagRelationships,
      {
        request:
          AssetTagsRelationshipConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST,
        payload: batch,
      },
      batch.tag.id,
      batch.assets
    );

    if (response instanceof BaseException) {
      // Do something
    }
  }

  yield put({
    type:
      AssetTagsRelationshipConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS,
    payload,
  });
}

export function* addAssetTagRelationshipSaga() {
  yield takeEvery(
    AssetTagsRelationshipConstants.ADD_ASSET_TAG_RELATIONSHIPS,
    addAssetTagRelationship
  );
}

export function* removeAssetTagRelationshipSaga() {
  yield takeEvery(
    AssetTagsRelationshipConstants.REMOVE_ASSET_TAG_RELATIONSHIPS,
    removeAssetTagRelationship
  );
}

export default [addAssetTagRelationshipSaga, removeAssetTagRelationshipSaga];
